import { combineReducers } from 'redux';
import { current, FilesBrowserState } from './current.reducer';
import { videoPlayer, VideoPlayerState } from './video-player.reducer';

export interface OldMediaAssetsState {
  current: FilesBrowserState;
  videoPlayer: VideoPlayerState;
}

export const oldMediaAssets = combineReducers<OldMediaAssetsState>({
  current,
  videoPlayer,
});
